import {Checkbox} from 'semantic-ui-react'
import {FaMoon} from 'react-icons/fa'
import {useDarkMode} from '@/features/dark-mode'
import './style.css'

export function DarkModeToggle() {
  const {userPrefersDarkMode, toggle} = useDarkMode()

  return (
    <div
      className='dark-mode-toggle'
      onClick={toggle}
    >
      <div className='label'>
        <FaMoon />
        Dark mode
      </div>
      <Checkbox
        toggle
        checked={userPrefersDarkMode}
        onChange={() => toggle()}
      />
    </div>
  )
}
